import { Col, InputRef, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import styled from "styled-components";
import {
  fetchUnApprovedRepairShop,
  sendPhoneNumber,
} from "../../../../apis/ReRegister/apis";
import {
  ReactComponent as CautionBlank,
  ReactComponent as Number1,
  ReactComponent as Number2,
  ReactComponent as Number3,
} from "../../../../assets/icons/AlarmFill.svg";
import { ReactComponent as Check } from "../../../../assets/icons/ReRegisterNotice.svg";
import Button from "../../../../components/atoms/Button";
import Buttons from "../../../../components/atoms/Buttons";
import Explain from "../../../../components/atoms/Explain";
import FormLabel from "../../../../components/atoms/FormLabel";
import SelectGroup from "../../../../components/atoms/Inputs/SelectGroup";
import TextInputs from "../../../../components/atoms/Inputs/TextInputs";
import RadioGroup from "../../../../components/atoms/RadioGroup";
import TextArea from "../../../../components/atoms/TextArea";
import {
  ALERT_MESSAGE,
  MIN_MORNITOR_WIDTH,
} from "../../../../components/constants";
import ImageTextUploader from "../../../../components/molecures/ImageTextUploader";
import PreviewUploader from "../../../../components/molecures/PreviewUploader";
import SearchAddress from "../../../../components/molecures/SearchAddressModal";
import { CustomForm } from "../../../../components/organisms/Form/index.styled";
import { UserInfoServiceForm } from "../../../../components/organisms/UserInfo/Service";
import useCounter from "../../../../hooks/useCounter";
import useModals from "../../../../hooks/useModals";
import { Media } from "../../../../model/Media";
import { HttpError } from "../../../../network/types";
import { PATH } from "../../../../routes/constants/path";
import { RepairShopMediaType } from "../../../../shared/enums";
import { yesOrNoArray } from "../../../../shared/options";
import {
  alertError,
  alertSuccess,
  validateEmail,
  validatePass,
  validatePhone,
} from "../../../../shared/utils";
import { theme } from "../../../../theme";
import {
  CountryType,
  NumberArray,
  PLACEHOLDER,
  SpecialCar,
  colFullProps,
  colHalfProps,
  initialDataForm,
  initialDivRef,
  initialInputRef,
  initialValidation,
} from "../../constants";
import CancelModal from "../CancelModal";
import CustomInputNumber from "../CustomInputNumber";
import { DataForm, ValidationStatus } from "../types";

interface RefInputItem {
  password: InputRef | null;
  rePass: InputRef | null;

  displayName: InputRef | null;
  managerName: InputRef | null;
  managerPhone: InputRef | null;
  managerEmail: InputRef | null;
  tel: InputRef | null;
  street: InputRef | null;
  detail: InputRef | null;
  businessMediaId: InputRef | null;
  repairShopMediaIds: InputRef | null;

  [index: string]: any | null;
}
interface RefDivItem {
  businessMediaId: HTMLDivElement | null;
  repairShopMediaIds: HTMLDivElement | null;
  managerPhone: HTMLDivElement | null;
  [index: string]: HTMLDivElement | null;
}

const RegisterForm: React.FC = () => {
  const nav = useNavigate();
  const location = useLocation();
  const fetchUnApprovedRepairShopMutation = useMutation(
    fetchUnApprovedRepairShop,
    {
      onSuccess: (res) => {
        const waTypes = [];
        if (res.domesticWAHandleable) waTypes.push(CountryType.Domestic);
        if (res.foreignWAHandleable) waTypes.push(CountryType.Foreign);
        const repairTypes = [];
        if (res.domesticLightRepairHandleable)
          repairTypes.push(CountryType.Domestic);
        if (res.foreignLightRepairHandleable)
          repairTypes.push(CountryType.Foreign);
        const batteryType = [];
        if (res.domesticBatteryExchangeable)
          batteryType.push(CountryType.Domestic);
        if (res.foreignBatteryExchangeable)
          batteryType.push(CountryType.Foreign);
        const engineOilType = [];
        if (res.domesticEngineOilExchangeable)
          engineOilType.push(CountryType.Domestic);
        if (res.foreignEngineOilExchangeable)
          engineOilType.push(CountryType.Foreign);
        const specialCars = [];
        if (res.bongoAcceptable) specialCars.push(SpecialCar.BONGO);
        if (res.porterHighTopAcceptable)
          specialCars.push(SpecialCar.PORTER_HIGH_TOP);
        if (res.porterLowTopAcceptable)
          specialCars.push(SpecialCar.PORTER_LOW_TOP);
        if (res?.id) setId(res.id);
        setDataForm({
          ...initialDataForm,
          ...res,
          subPhone1:
            res.subManagerPhoneList?.length > 0
              ? res.subManagerPhoneList[0]
              : "",
          subPhone2:
            res.subManagerPhoneList?.length > 1
              ? res.subManagerPhoneList[1]
              : "",
          businessMediaId: res.businessMedia?.id || 0,
          repairShopMedias: [],
          frontMedia: res.repairShopMedias?.find(
            (val) => val.type === RepairShopMediaType.FRONT
          )?.media,
          allMedia: res.repairShopMedias?.find(
            (val) => val.type === RepairShopMediaType.ALL
          )?.media,
          inMedia: res.repairShopMedias?.find(
            (val) => val.type === RepairShopMediaType.IN
          )?.media,
          batteryType,
          engineOilType,
          specialCars,
          repairTypes,
        });

        form.setFieldsValue({ repairShopOption: { ...res.repairShopOption } });
      },
      onError: (error: HttpError) => {
        alertError(error.message);
        nav(PATH.LOGIN);
      },
    }
  );

  const sendPhoneAuthMutation = useMutation(sendPhoneNumber, {
    onSuccess: (res) => {
      startCounter();
      setDataForm({ ...dataForm, authTokenId: res.authTokenId });
      alertSuccess("문자가 전송되었습니다.인증 코드를 확인해주세요.");
    },
    onError: () => {},
  });

  const { resetCounter, startCounter } = useCounter(180);
  const inputRef = useRef<RefInputItem>(initialInputRef);
  const divRef = useRef<RefDivItem>(initialDivRef);
  const { openModal, closeModal } = useModals();
  const [id, setId] = useState<number>(0);
  const [dataForm, setDataForm] = useState<DataForm>(initialDataForm);

  const [isLoading, setLoading] = useState(false);

  const initialStatus: { [index: string]: ValidationStatus } = {};
  Object.keys(dataForm).map((value) => {
    initialStatus[value] = initialValidation;
    return 0;
  });

  const [status, setStatus] = useState<{ [index: string]: ValidationStatus }>({
    ...initialStatus,
    rePass: initialValidation,
  });

  useEffect(() => {
    const passMessages = validatePass(dataForm.password);

    setStatus({
      ...status,
      password: {
        status:
          dataForm.password.length === 0
            ? undefined
            : passMessages.length === 0
            ? "success"
            : "error",
        explain:
          dataForm.password.length === 0
            ? undefined
            : passMessages.length === 0
            ? "올바른 비밀번호 입니다."
            : passMessages.join(" "),
      },
    });
  }, [dataForm.password, dataForm.rePass]);

  const debouncedPhoneResend = () => {
    setLoading(true);
    resetCounter();
    setStatus({ ...status, managerPhone: initialValidation });
    if (status.managerPhone.status !== "error") {
      setDataForm({ ...dataForm, authTokenId: "" });
      setStatus({
        ...status,
        auth: initialValidation,
        managerPhone: initialValidation,
      });
      sendPhoneAuthMutation.mutate({
        key: dataForm.managerPhone,
      });
    }
  };

  useEffect(() => {
    if (isLoading)
      setTimeout(() => {
        if (!sendPhoneAuthMutation?.isLoading) setLoading(false);
      }, 1000);
  }, [isLoading, sendPhoneAuthMutation.isLoading]);

  useEffect(() => {
    const sch = location.search;
    const params = new URLSearchParams(sch);
    const keyword = params.get("repairShopAId");
    if (keyword) fetchUnApprovedRepairShopMutation.mutate(keyword);
  }, []);

  const [form] = useForm();

  return (
    <FormContatiner>
      <FormWrapper>
        <StyledNoticeWrapper>
          <Row gutter={[8, 0]}>
            <Col flex="0 0 24px">
              <Check />
            </Col>
            <Col flex="1 0 0">
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <StyledNoticeTitle>
                    제휴 신청이 완료되었습니다!
                  </StyledNoticeTitle>
                </Col>
                <Col>
                  <StyledNoticeExplain>
                    입력하신 휴대폰 번호로 담당자가 승인 혹은 반려 안내 드릴
                    예정입니다.
                  </StyledNoticeExplain>
                </Col>
              </Row>
            </Col>
          </Row>{" "}
        </StyledNoticeWrapper>
        <Row gutter={[60, 60]} justify="center">
          <FullCol>
            <RegisterTitle>기본정보</RegisterTitle>
          </FullCol>
          <FullCol>
            <Row>
              <HalfCol>
                <FormLabel>아이디</FormLabel>
                <TextInputs
                  ref={(ref) => {
                    inputRef.current.repairShopAId = ref;
                  }}
                  disabled
                  showCount={false}
                  isNotBordered
                  onChange={() => {}}
                  placeholder={PLACEHOLDER.aId}
                  value={dataForm.repairShopAId}
                  maxLength={16}
                />
              </HalfCol>
              <HalfCol />
            </Row>
          </FullCol>

          <HalfCol>
            <FormLabel>상호명</FormLabel>
            <TextInputs
              isNotBordered
              disabled
              ref={(ref) => {
                inputRef.current.displayName = ref;
              }}
              showCount={false}
              status={status.displayName.status}
              explain={status.displayName.explain}
              placeholder={PLACEHOLDER.diplayName}
              onChange={(e) => {
                setStatus({
                  ...status,
                  displayName: initialValidation,
                });
                setDataForm({ ...dataForm, displayName: e });
              }}
              maxLength={100}
              value={dataForm.displayName}
            />
          </HalfCol>
          <InputWrapper {...colHalfProps}>
            <FormLabel>담당자 성함</FormLabel>
            <TextInputs
              disabled
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.managerName = ref;
              }}
              status={status.managerName.status}
              explain={status.managerName.explain}
              placeholder={PLACEHOLDER.manageName}
              onChange={(e) => {
                const isNum = !e?.search(/[0-9]/g);
                setStatus({
                  ...status,
                  managerName: {
                    status: isNum ? "error" : undefined,
                    explain: isNum ? ALERT_MESSAGE.NEED_NAME : undefined,
                  },
                });
                setDataForm({ ...dataForm, managerName: e });
              }}
              maxLength={100}
              value={dataForm.managerName}
            />
          </InputWrapper>
          <FullCol
            ref={(ref) => {
              divRef.current.managerPhone = ref;
            }}
          >
            <FormLabel>휴대폰번호</FormLabel>

            <TextInputs
              disabled
              ref={(ref) => {
                inputRef.current.managerPhone = ref;
              }}
              onPressEnter={
                dataForm.managerPhone.trim().length === 0 ||
                !validatePhone(dataForm.managerPhone)
                  ? () => {
                      setStatus({
                        ...status,
                        managerPhone: {
                          status: "error",
                          explain: ALERT_MESSAGE.WRONG_PHONE,
                        },
                      });
                    }
                  : !isLoading
                  ? debouncedPhoneResend
                  : undefined
              }
              isNotBordered
              showCount={false}
              value={dataForm.managerPhone}
              placeholder={PLACEHOLDER.phone}
              status={status.managerPhone.status}
              explain={status.managerPhone.explain}
              maxLength={20}
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e !== "")
                  setStatus({
                    ...status,
                    managerPhone: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });
                setDataForm({ ...dataForm, managerPhone: e });
              }}
            />
            <Explain
              status="question"
              explain="휴대폰 번호로 심사 결과를 알려드립니다."
            />
          </FullCol>
          <HalfCol>
            <FormLabel notRequired>예비번호1</FormLabel>
            <TextInputs
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.subPhone1 = ref;
              }}
              disabled
              value={dataForm.subPhone1}
              placeholder={PLACEHOLDER.phone}
              status={status.subPhone1?.status}
              explain={status.subPhone1?.explain}
              maxLength={20}
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e !== "")
                  setStatus({
                    ...status,
                    subPhone1: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });

                setDataForm({ ...dataForm, subPhone1: e });
              }}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel notRequired> 예비번호2</FormLabel>
            <TextInputs
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.subPhone2 = ref;
              }}
              disabled
              value={dataForm.subPhone2}
              placeholder={PLACEHOLDER.phone}
              status={status.subPhone2?.status}
              explain={status.subPhone2?.explain}
              maxLength={20}
              onChange={(e) => {
                const isPass = validatePhone(e);
                if (e !== "")
                  setStatus({
                    ...status,
                    subPhone2: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_PHONE,
                    },
                  });

                setDataForm({ ...dataForm, subPhone2: e });
              }}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>이메일 주소</FormLabel>
            <TextInputs
              isNotBordered
              ref={(ref) => {
                inputRef.current.managerEmail = ref;
              }}
              disabled
              showCount={false}
              status={status.managerEmail.status}
              explain={status.managerEmail.explain}
              placeholder={PLACEHOLDER.email}
              value={dataForm.managerEmail}
              onChange={(e) => {
                const isPass = validateEmail(e);
                setDataForm({ ...dataForm, managerEmail: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    managerEmail: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.WRONG_EMAIL,
                    },
                  });
              }}
              maxLength={100}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>매장 대표번호</FormLabel>
            <TextInputs
              disabled
              isNotBordered
              showCount={false}
              ref={(ref) => {
                inputRef.current.tel = ref;
              }}
              placeholder={PLACEHOLDER.phone}
              status={status.tel.status}
              explain={status.tel.explain}
              value={dataForm.tel}
              onChange={(e) => {
                const isPass = /^[0-9]{2,3}[0-9]{3,4}[0-9]{4}/.test(e);
                e = e.replaceAll("-", "");
                setDataForm({ ...dataForm, tel: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    tel: {
                      status: isPass ? undefined : "error",
                      explain: isPass ? undefined : ALERT_MESSAGE.NEED_NUMBER,
                    },
                  });
              }}
              maxLength={11}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>사업자등록번호</FormLabel>
            <TextInputs
              isNotBordered
              disabled
              ref={(ref) => {
                inputRef.current.businessRegistrationNumber = ref;
              }}
              showCount={false}
              placeholder={PLACEHOLDER.businessRegistrationNumber}
              status={status.businessRegistrationNumber.status}
              explain={status.businessRegistrationNumber.explain}
              value={dataForm.businessRegistrationNumber}
              onChange={(e) => {
                const isPass = /([0-9]{3})-?([0-9]{2})-?([0-9]{5})/.test(e);
                e.replaceAll("-", "");
                setDataForm({ ...dataForm, businessRegistrationNumber: e });
                if (e !== "")
                  setStatus({
                    ...status,
                    businessRegistrationNumber: {
                      status: isPass ? undefined : "error",
                      explain: isPass
                        ? undefined
                        : ALERT_MESSAGE.WRONG_BUSI_NUMBER,
                    },
                  });
              }}
              maxLength={10}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel notRequired>사업자 등록증 상호명</FormLabel>
            <TextInputs
              disabled
              isNotBordered
              showCount={false}
              status={status.repairShopName.status}
              explain={status.repairShopName.explain}
              placeholder="-"
              value={dataForm.repairShopName}
              maxLength={100}
              onChange={(e) => {
                setStatus({ ...status, repairShopName: initialValidation });
                setDataForm({ ...dataForm, repairShopName: e });
              }}
            />
          </HalfCol>
          <FullCol
            ref={(ref) => {
              divRef.current.businessMediaId = ref;
            }}
          >
            <FormLabel>사업자 등록증</FormLabel>
            <ImageTextUploader
              folder="tirepick_repairshop_web_business_img/"
              max={1}
              disabled
              onUpload={(e: Media[]) => {
                if (e)
                  if (e.length > 0)
                    if (e[0].id) {
                      setDataForm({
                        ...dataForm,
                        businessMediaId: e[0].id,
                        businessMedia: e[0],
                      });
                      setStatus({
                        ...status,
                        businessMediaId: {
                          status: undefined,
                          explain: undefined,
                        },
                      });
                    }
              }}
              imageList={dataForm.businessMedia ? [dataForm.businessMedia] : []}
              onRemove={() => {
                setDataForm({
                  ...dataForm,
                  businessMediaId: -1,
                  businessMedia: undefined,
                });
              }}
              errorExplain={status.businessMediaId.explain}
            />

            <Explain
              status="question"
              explain="첨부파일은 최대 3MB, 5개 까지 사진파일 형식만 가능합니다. (JPG, PNG, GIF)"
            />
          </FullCol>

          <FullCol>
            <FormLabel>매장 주소</FormLabel>
            <TextInputs
              value={dataForm.street}
              ref={(ref) => {
                inputRef.current.street = ref;
              }}
              onClick={() => {
                setStatus({
                  ...status,
                  street: initialValidation,
                  detail: initialValidation,
                });

                openModal(
                  <SearchAddress
                    setAddress={(e: any) => {
                      setDataForm({ ...dataForm, ...e });
                    }}
                    setShowSearchAddress={() => {
                      closeModal();
                    }}
                  />
                );
              }}
              placeholder={PLACEHOLDER.address}
              isNotBordered
              status={status.street.status}
              explain={status.street.explain}
              onChange={() => {}}
              disabled
              additionalBtn={
                <Button
                  size="large"
                  type="primary"
                  ghost
                  disabled
                  onClick={() => {
                    setStatus({
                      ...status,
                      street: initialValidation,
                      detail: initialValidation,
                    });
                    openModal(
                      <SearchAddress
                        setAddress={(e: any) =>
                          setDataForm({ ...dataForm, ...e })
                        }
                        setShowSearchAddress={closeModal}
                      />
                    );
                  }}
                >
                  주소 찾기
                </Button>
              }
            />
            <TextInputs
              placeholder={PLACEHOLDER.detailAddress}
              isNotBordered
              ref={(ref) => {
                inputRef.current.street = ref;
              }}
              disabled
              showCount={false}
              status={status.detail.status}
              explain={status.detail.explain}
              value={dataForm.detail}
              onChange={(e) => {
                setDataForm({ ...dataForm, detail: e });
                setStatus({
                  ...status,
                  street: initialValidation,
                  detail: initialValidation,
                });
              }}
              maxLength={50}
            />
          </FullCol>

          <FullCol>
            <FormTitle>예약 정보</FormTitle>
          </FullCol>
          <FullCol>
            <FormLabel>평일 하루 최대 몇개까지 예약이 가능하신가요?</FormLabel>
            <CustomInputNumber
              min={0}
              disabled
              maxLength={100}
              value={dataForm.maximumWeekdayVehicleCount}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  maximumWeekdayVehicleCount: Number(e),
                });
              }}
            />
          </FullCol>
          <FullCol>
            <FormLabel>
              주말(공휴일) 하루 최대 몇대까지 예약 가능하신가요?
            </FormLabel>
            <CustomInputNumber
              min={0}
              disabled
              maxLength={100}
              value={dataForm.maximumWeekendVehicleCount}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  maximumWeekendVehicleCount: Number(e),
                });
              }}
            />
          </FullCol>
          <FullCol>
            <FormTitle>매장 환경</FormTitle>
          </FullCol>
          <HalfCol>
            <FormLabel>보유 리프트</FormLabel>
            <SelectGroup
              disabled
              placeholder={PLACEHOLDER.select}
              selectArray={NumberArray(10)}
              status={status.liftCount.status}
              explain={status.liftCount.explain}
              onChange={(e) =>
                setDataForm({ ...dataForm, liftCount: Number(e) })
              }
              value={dataForm.liftCount}
            />
          </HalfCol>
          <HalfCol>
            <FormLabel>보유 정비인력(명)</FormLabel>
            <SelectGroup
              disabled
              placeholder={PLACEHOLDER.select}
              selectArray={NumberArray(10)}
              status={status.employeeCount.status}
              explain={status.employeeCount.explain}
              onChange={(e) =>
                setDataForm({ ...dataForm, employeeCount: Number(e) })
              }
              value={dataForm.employeeCount}
            />
          </HalfCol>
          <FullCol>
            <FormLabel>고객 대기실 보유 여부</FormLabel>
            <RadioGroup
              disabled
              options={yesOrNoArray}
              onChange={(e) => {
                setDataForm({
                  ...dataForm,
                  waitingRoomExistence: e.target.value,
                });
              }}
              value={dataForm.waitingRoomExistence}
            />
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.allMedia = ref;
            }}
          >
            <FormLabel>매장 전체 사진</FormLabel>
            <PreviewUploader
              disabled
              inputKey="repairShopMedias_all"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, allMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  allMedia: e[0],
                });
              }}
              onRemove={undefined}
              max={1}
              imageList={dataForm.allMedia ? [dataForm.allMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.allMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper>
                    <Explain
                      status={status.allMedia.status}
                      explain={status.allMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number1 fill={theme.colors.gray1} />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-전체 (입점 매장의 경우 건물의 전체 모습이 보이도록 촬영
                    바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number1 fill={theme.colors.gray1} />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장 소개 페이지에서 대표 사진으로 설정됩니다.
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.frontMedia = ref;
            }}
          >
            <FormLabel>매장 정면 사진</FormLabel>
            <PreviewUploader
              disabled
              inputKey="repairShopMedias_front"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, frontMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  frontMedia: e[0],
                });
              }}
              onRemove={undefined}
              max={1}
              imageList={dataForm.frontMedia ? [dataForm.frontMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.frontMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper>
                    <Explain
                      status={status.frontMedia.status}
                      explain={status.frontMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}

              <FullCol>
                <ImageExplainWrapper>
                  {" "}
                  <IconWrapper>
                    <Number2 />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-정면 (간판 및 리프트 수를 확인할 수 있도록 촬영
                    바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>

              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol
            ref={(ref) => {
              divRef.current.inMedia = ref;
            }}
          >
            <FormLabel>매장 내부 사진</FormLabel>
            <PreviewUploader
              disabled
              inputKey="repairShopMedias_in"
              folder="repairShop_web_medias"
              onUpload={(e) => {
                setStatus({ ...status, inMedia: initialValidation });
                setDataForm({
                  ...dataForm,
                  inMedia: e[0],
                });
              }}
              onRemove={undefined}
              max={1}
              imageList={dataForm.inMedia ? [dataForm.inMedia] : []}
            />

            <Row gutter={[0, 8]} style={{ marginTop: "8px" }} align="top">
              {status.inMedia?.explain && (
                <FullCol>
                  <ImageExplainWrapper>
                    <Explain
                      status={status.inMedia.status}
                      explain={status.inMedia.explain}
                    />
                  </ImageExplainWrapper>
                </FullCol>
              )}

              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <Number3 />
                  </IconWrapper>
                  <ImageExplainSpan>
                    매장-내부 (고객 대기 공간이 보이도록 촬영 바랍니다.)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
              <FullCol>
                <ImageExplainWrapper>
                  <IconWrapper>
                    <CautionBlank />
                  </IconWrapper>
                  <ImageExplainSpan>
                    첨부파일은 최대 3MB 사진파일 형식만 가능합니다. (JPG, PNG,
                    GIF)
                  </ImageExplainSpan>
                </ImageExplainWrapper>
              </FullCol>
            </Row>
          </FullCol>
          <FullCol>
            <FormTitle>정비가능 항목</FormTitle>
          </FullCol>
          <FullCol>
            <CustomForm form={form} initialValues={{ ...dataForm }}>
              <UserInfoServiceForm form={form} readonly />
            </CustomForm>
          </FullCol>
          <FullCol>
            <FormTitle>추가사항</FormTitle>
          </FullCol>
          <FullCol>
            <FormLabel notRequired>참고 및 요청사항</FormLabel>
            <TextArea
              disabled
              placeholder="-"
              value={dataForm.moreDetail}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  moreDetail:
                    e.target.value === "" ? undefined : e.target.value,
                })
              }
              maxWidth="100%"
              maxLength={100}
            />
          </FullCol>
          <FullCol>
            <FormLabel notRequired>매장 한마디</FormLabel>
            <TextArea
              placeholder="-"
              value={dataForm.introduction || ""}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  introduction:
                    e.target.value === "" ? undefined : e.target.value,
                })
              }
              disabled
              maxWidth="100%"
              maxLength={100}
            />
          </FullCol>
          {/* <FullCol>
            <FormLabel>개인정보 수집 및 이용동의</FormLabel>
            <StyledTable
              pagination={false}
              style={{ width: "100%" }}
              columns={[
                {
                  dataIndex: "type",
                  title: "구분",
                  key: 1,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "items",
                  title: "수집 항목",
                  key: 2,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "purpose",
                  title: "이용목적",
                  key: 3,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
                {
                  dataIndex: "saveDate",
                  title: "보유기간",
                  key: 4,
                  onCell: () => {
                    return { className: "noHover" };
                  },
                },
              ]}
              scroll={{ x: 700 }}
              dataSource={[
                {
                  key: 1,
                  type: "필수",
                  items: "이름,휴대폰번호,이메일",
                  purpose: "제휴 신청",
                  saveDate: "신청일로부터 1개월",
                },
              ]}
            />
            <Explain
              status="caution"
              explain="고객님께서는 동의를 거부할 권리가 있으나, 미 동의 시 해당 서비스를 이용할 수 없습니다."
            />
          </FullCol>
          <FullCol>
            <StyledDiv>
              <CheckBox
                value={[
                  dataForm.marketingEmailReceivable &&
                    dataForm.marketingMessageReceivable &&
                    dataForm.marketingPushReceivable,
                ]}
                disabled
                onChange={onCheckMarketing}
                options={marketingPossibleArray}
              />
            </StyledDiv>
          </FullCol> */}
          <FullCol>
            <InputsContainer>
              <BtnWrapper>
                <ButtonWrapper>
                  <Buttons
                    size="block"
                    isSecondary
                    text="제휴 취소"
                    onClick={() => {
                      openModal(<CancelModal id={id} />);
                    }}
                  />
                </ButtonWrapper>

                <ButtonWrapper>
                  <Buttons
                    size="block"
                    text="로그아웃"
                    onClick={() => nav(PATH.LOGIN)}
                  />
                </ButtonWrapper>
              </BtnWrapper>
            </InputsContainer>
          </FullCol>
        </Row>
      </FormWrapper>
    </FormContatiner>
  );
};

export default RegisterForm;

const HalfCol = forwardRef<HTMLDivElement, { children?: any }>((props, ref) => (
  <InputWrapper ref={ref} {...colHalfProps}>
    {props.children}
  </InputWrapper>
));
const FullCol = forwardRef<HTMLDivElement, { children?: any }>((props, ref) => (
  <InputWrapper ref={ref} {...colFullProps}>
    {props.children}
  </InputWrapper>
));

const FormContatiner = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  overflow: hidden;
  overflow-y: auto;
`;
const FormWrapper = styled.div`
  max-width: 700px;
`;
const InputWrapper = styled(Col)`
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 360px;
    justify-content: center;
    align-items: center;
    align-content: center;
  }
`;
const FormTitle = styled.span`
  ${theme.typo.title.t32};
  margin-top: 120px;
`;
const BtnWrapper = styled.form`
  display: flex;
  max-width: 400px;
  justify-content: space-between;
  margin-top: 120px;
  margin-bottom: 200px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 320px;
    justify-content: space-between;
  }
`;

const RegisterTitle = styled.span`
  ${theme.typo.title.t32};
  margin-top: 40px;
`;
const ButtonWrapper = styled.div`
  width: 192px;
  height: 54px;
  margin: 8px;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    width: 156px;
    margin: 4px;
  }
`;
const InputsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const ImageExplainSpan = styled.span`
  ${theme.typo.body.r14};
  line-height: 18px;
  margin-left: 4px;
`;
const ImageExplainWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`;
const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
`;

const StyledNoticeWrapper = styled.div`
  width: 700px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  margin-bottom: 60px;
  /* Main/Primary 09 */

  background: #fbf9ff;
  /* Alert/Admin_purple */

  border: 1px solid #5e3ff7;
  border-radius: 8px;
`;
const StyledNoticeTitle = styled.div`
  ${theme.typo.body.r16};
  font-weight: 700;
  color: ${theme.colors.mainPrimary3};
`;
const StyledNoticeExplain = styled.div`
  ${theme.typo.body.r14};
  color: ${theme.colors.gray1};
`;
